import { initErrorMonitoring } from '@/monitoring/sentry.util.ts';

if (import.meta.env.DEV) {
  await import('react-scan').then(({ scan }) => {
    scan({ enabled: true });
  });
}

import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import 'flag-icons/css/flag-icons.min.css';

import './styles/flag-icons.overrides.css';
import './config/i18n/i18n.ts';
import App from './App';

initErrorMonitoring();
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
